import React, { createContext, useContext, ReactNode } from 'react';

export type FeatureFlags = { [key: string]: boolean | string | number };

/** Stable reference when `flags` is omitted so Provider value identity does not change every render. */
const EMPTY_FEATURE_FLAGS: FeatureFlags = {};

const FeatureFlagContext = createContext<FeatureFlags | undefined>(undefined);

export function FeatureFlagProvider({ children, flags }: { children: ReactNode; flags: FeatureFlags | undefined }) {
  return <FeatureFlagContext.Provider value={flags ?? EMPTY_FEATURE_FLAGS}>{children}</FeatureFlagContext.Provider>;
}

export function useBooleanFlagValue(flagKey: string, defaultValue: boolean): boolean {
  const flags = useContext(FeatureFlagContext);

  if (!flags) {
    console.warn(`useBooleanFlagValue("${flagKey}") used outside of FeatureFlagProvider. Returning default value.`);

    return defaultValue;
  }

  const value = flags[flagKey];

  if (value === undefined) {
    return defaultValue;
  }

  return Boolean(value);
}
